import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { templateData } from '../data/templateData';
import './checkin.css';
import { useAuth } from '../hooks/useAuth';
import ProfessionalChatbot from '../components/ProfessionalChatbot';
import Alert from "../components/Alert";
import PhoneInput from "../components/PhoneInput"
import Voice from "../components/Voice2"

const AutoCheckIn = () => {
  const { id } = useParams();
  const [adhoc, setAdhoc] = useState(false);
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user, logout } = useAuth();
  const [showAlert, setShowAlert] = useState(false);
  
  const [prompts_list, setPrompts_list] = useState([]);

  const [selected_prompts, setSelected_prompts] = useState({});

  const API_URL = process.env.NODE_ENV === 'development' ? "https://demo.aiguardian.io/agent-backend": "/agent-backend";
  
  const [alertMessage, setAlertMessage] = useState("");

  const [expandedKey, setExpandedKey] = useState(null);

  const toggleKey = (key) => {
    setExpandedKey(prev => (prev === key ? null : key));
  };


  const triggerAlert = (msg) => {
    setAlertMessage(msg);
    setShowAlert(true);
  };

    useEffect(() => {
    // Simulate API call
    console.log(id)

    setTimeout(() => {
      if (id == "Adhoc Task")
        setAdhoc(true)
      
      const foundtemplate = templateData.find(template => template.service === id);
      //console.log(id, "hello",foundtemplate)
      if (foundtemplate) {
        setTemplate(foundtemplate);
      } else {
        setError('assistant not found');
      }
      setLoading(false);
    }, 100);

  }, [id]);
  

  useEffect(
    () => {
      async function fetchData() {
        // You can await here
            const response = await fetch(API_URL+'/api/get_prompts',
                {
                  method: "GET",          
                  headers: { "Content-Type": "application/json","Authorization": "Bearer "+user.token },
                  
                }
              ) ;
            setPrompts_list(await response.json())
        
      }
    fetchData();

    // Simulate API call

    }, []);


  if (loading) {
    return <div>Loading details...</div>;
  }

  const addKeyValue = (key, value) => {
    setSelected_prompts(prevDict => ({
      ...prevDict,
      [key]: value,
    }));
  };

  // Remove a key-value pair
  const removeKey = (key) => {
    setSelected_prompts(prevDict => {
      const { [key]: _, ...rest } = prevDict; // Omit the key
      return rest;
    });
  };

  const handleSelect = (e) =>{

    console.log(e.target.value)
    if (e.target.name == "temperature" && e.target.value == "Fever"){
       console.log("FFFFFFFF")
       const fever = prompts_list.filter(item => item.prompt_id == 'fever_PROMPT')
       if (fever.length > 0)
           //question_list.push({"fever_PROMPT":fever[0].prompt})          
          addKeyValue("Fever",fever)         
        
    }else if (e.target.name == "temperature" && e.target.value != "Fever"){
      removeKey("Fever")
    }
  
    if (e.target.name == "spo2" && e.target.value == "Low"){
      console.log("FFFFFFFF")
      const fever = prompts_list.filter(item => item.prompt_id == 'SPO2_low_PROMPT')
      if (fever.length > 0)
          //question_list.push({"fever_PROMPT":fever[0].prompt})          
         addKeyValue("SPO2 Low",fever)         
       
   }else if (e.target.name == "spo2" && e.target.value != "Low"){
         removeKey("SPO2 Low")
   }


   if (e.target.name == "heartRate" && e.target.value == "High"){
    
    const fever = prompts_list.filter(item => item.prompt_id == 'Heart_Rate_High_PROMPT')
    if (fever.length > 0)
        //question_list.push({"fever_PROMPT":fever[0].prompt})          
       addKeyValue("Heart Rate High",fever)         
     
    }else if (e.target.name == "heartRate" && e.target.value != "High"){
          removeKey("Heart Rate High")
    }

    if (e.target.name == "heartRate" && e.target.value == "Low"){
    
      const fever = prompts_list.filter(item => item.prompt_id == 'Heart_Rate_Low_PROMPT')
      if (fever.length > 0)
          //question_list.push({"fever_PROMPT":fever[0].prompt})          
         addKeyValue("Heart Rate Low",fever)         
       
      }else if (e.target.name == "heartRate" && e.target.value != "Low"){
            removeKey("Heart Rate Low")
    }

    if (e.target.name == "bloodPressure" && e.target.value == "High"){
    
      const fever = prompts_list.filter(item => item.prompt_id == 'BP_High_PROMPT')
      if (fever.length > 0)
          //question_list.push({"fever_PROMPT":fever[0].prompt})          
         addKeyValue("BP High",fever)         
       
      }else if (e.target.name == "bloodPressure" && e.target.value != "High"){
            removeKey("BP High")
    }    

    if (e.target.name == "bloodPressure" && e.target.value == "Low"){
    
      const fever = prompts_list.filter(item => item.prompt_id == 'BP_Low_PROMPT')
      if (fever.length > 0)
          //question_list.push({"fever_PROMPT":fever[0].prompt})          
         addKeyValue("BP Low",fever)         
       
      }else if (e.target.name == "bloodPressure" && e.target.value != "Low"){
            removeKey("BP Low")
    }       

        
    // if (e.target.bloodPressure.value == "Low"){
    //   const fever = prompts_list.filter(item => item.prompt_id == 'BP_Low_PROMPT')
    //    if (fever.length > 0)
    //        //question_list.push({"BP_Low_PROMPT":fever[0].prompt})
    //        setSelected_prompts(prev => [...prev, {"fever_PROMPT":fever[0].prompt}]) 

    // }
      

    // console.log(selected_prompts)

  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("submit",e.target.name.value,e.target.phone.value)
    const question_list = {}

    let vital_signs = [0,0,0,0,0,0]
    if (e.target.temperature.value == "Fever"){
      console.log(prompts_list)
       const fever = prompts_list.filter(item => item.prompt_id == 'fever_PROMPT')
       if (fever.length > 0)
           //question_list.push({"Fever":fever[0].prompt.map(item => item.prompt)})
           question_list["Fever"] = fever[0].prompt.map(item => item.prompt)

    }
        // vital_signs[0] = 1
    if (e.target.spo2.value == "Low"){
       const fever = prompts_list.filter(item => item.prompt_id == 'SPO2_low_PROMPT')
       if (fever.length > 0)
           //question_list.push({"SPO2_Low":fever[0].prompt.map(item => item.prompt)})
           question_list["SPO2_Low"] = fever[0].prompt.map(item => item.prompt)
    }
        vital_signs[1] = 1
    if (e.target.heartRate.value == "High"){
      const fever = prompts_list.filter(item => item.prompt_id == 'Heart_Rate_High_PROMPT')
       if (fever.length > 0)
           //question_list.push({"Heart_Rate_High":fever[0].prompt.map(item => { if (item.followUps){return item.prompt + " - "+item.followUps.join(" - ")} else return item.prompt})})
           question_list["Heart_Rate_High"] = fever[0].prompt.map(item => { if (item.followUps){return item.prompt + " - "+item.followUps.join(" - ")} else return item.prompt})
    }
        vital_signs[2] = 1  
    if (e.target.heartRate.value == "Low"){
      const fever = prompts_list.filter(item => item.prompt_id == 'Heart_Rate_Low_PROMPT')
       if (fever.length > 0)
           //question_list.push({"Heart_Rate_Low":fever[0].prompt.map(item => item.prompt)})
           question_list["Heart_Rate_Low"] = fever[0].prompt.map(item => item.prompt)

    }
        vital_signs[3] = 1
    if (e.target.bloodPressure.value == "High"){
      const fever = prompts_list.filter(item => item.prompt_id == 'BP_High_PROMPT')
       if (fever.length > 0)
           //question_list.push({"BP_High":fever[0].prompt.map(item => item.prompt)})
           question_list["BP_High"] = fever[0].prompt.map(item => item.prompt)

    }
        vital_signs[4] = 1
    if (e.target.bloodPressure.value == "Low"){
      const fever = prompts_list.filter(item => item.prompt_id == 'BP_Low_PROMPT')
       if (fever.length > 0)
           //question_list.push({"BP_Low":fever[0].prompt.map(item => item.prompt)})
           question_list["BP_Low"] = fever[0].prompt.map(item => item.prompt)

    }
        vital_signs[5] = 1
    if ( Object.keys(question_list).length == 0){
      //alert("Please select at least one abnormal option")
      triggerAlert("Please select at least one abnormal option")
      return 
    }

    console.log(question_list)
    //return

    const newTask = {
      "type":  "auto check-in",
      "name": e.target.name.value,
      "phone_number": e.target.phone_code.value+e.target.phone.value,      
      //"vital_signs":vital_signs,  
      "question_list":question_list,
      "lang": e.target.lang.value,   
    }
    if (e.target.time.value){
      newTask["call_at"] = e.target.time.value
    }

    // const data = {"agent_name":"test-call", "meta":{"vital_signs":vital_signs,"phone_number":e.target.phone.value,
    //                "name":e.target.name.value,"transfer_to":e.target.phone.value}}
    // console.log(e.target.time.value)
    // if (e.target.time.value){
    //     data["call_at"] = e.target.time.value
    //   }               
    
    try {
      const response = await fetch(API_URL+'/api/createjob',
        {
          method: "POST",          
          headers: { "Content-Type": "application/json","Authorization": "Bearer "+user.token },
          body: JSON.stringify(newTask)
        }
      ) ;

      if (response.ok) {
        //alert('Successfully send request!')
        triggerAlert("Successfully send request.")
      }
      else
        throw new Error('Something went wrong');      

    } catch (error) {
      console.log('There was an error');
      //alert('There was an error')
      triggerAlert("There was an error")
    }    
                   
  }
  
  return (
    <div className="container">
      {/* Header 
      <div className="header-1">
        <button className="back-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          Back to Roles
        </button>
      </div>
      */}
      {/* Main Content */}
      <div className="main-content-1">
        {/* Left Column - Profile */}
        <div className="profile-column">
          <div className="profile-image-container">
            <img 
              src={template.photo}
              alt="Healthcare professional" 
              className="profile-image"
            />
           
          </div>
          
          <div className="profile-info">
            <h2 className="profile-name">{template.name}</h2>
            <h3 className="profile-role">{template.service}</h3>
            <p className="profile-description">
               {template.introduction}
            </p>
          </div>
        </div>

        {/* Right Column - Details */}
        <div className="details-column">
          <h1 className="page-title">Patient Contact Information</h1>
          
  
          <form onSubmit={handleSubmit}>
          {/* Action Buttons */}
          <div className="action-buttons">              
            <div className="action-button">
              <div className="action-icon phone-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>              
              {/* <input
                  type="text"
                  id="phone"
                  name="phone" 
                  placeholder="+65 phone number"    
                  className={`form-control`}                               
                /> */}

                <PhoneInput/>

            </div>
            
            <div className="action-button">
              <div className="action-icon settings-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"  viewBox="0 0 16 16">
                   <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
              </svg>
              </div>
              <input
                  type="text"
                  id="name"
                  name="name" 
                  placeholder="patient name"    
                  className={`form-control`}                               
                />
            </div>

            <div className="action-button">
              <div className="action-icon settings-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <input
                  type="datetime-local"
                  id="time"
                  name="time" 
                  placeholder=""                   
                  className={`form-control`}                               
                />
            </div>          
          
            <div className="action-button">
              <div className="action-icon settings-icon">
              <svg fill="currentColor" width="32" height="32" stroke="currentColor" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><title>ionicons-v5-l</title><path d="M478.33,433.6l-90-218a22,22,0,0,0-40.67,0l-90,218a22,22,0,1,0,40.67,16.79L316.66,406H419.33l18.33,44.39A22,22,0,0,0,458,464a22,22,0,0,0,20.32-30.4ZM334.83,362,368,281.65,401.17,362Z"/><path d="M267.84,342.92a22,22,0,0,0-4.89-30.7c-.2-.15-15-11.13-36.49-34.73,39.65-53.68,62.11-114.75,71.27-143.49H330a22,22,0,0,0,0-44H214V70a22,22,0,0,0-44,0V90H54a22,22,0,0,0,0,44H251.25c-9.52,26.95-27.05,69.5-53.79,108.36-31.41-41.68-43.08-68.65-43.17-68.87a22,22,0,0,0-40.58,17c.58,1.38,14.55,34.23,52.86,83.93.92,1.19,1.83,2.35,2.74,3.51-39.24,44.35-77.74,71.86-93.85,80.74a22,22,0,1,0,21.07,38.63c2.16-1.18,48.6-26.89,101.63-85.59,22.52,24.08,38,35.44,38.93,36.1a22,22,0,0,0,30.75-4.9Z"/></svg>
              </div>
              <select 
                        id="lang"
                        name="lang"
                        className="template-select"
                    >
                        <option value="">Select Language</option>
                        <option value="en">English</option>
                        <option value="cn">Chinese</option>
                        <option value="my">Malay</option>
                        <option value="in">Tamil</option>
                        <option value="za">Afrikaans</option>
                        <option value="sa">Arabic</option>
                        <option value="am">Armenian</option>
                        <option value="az">Azerbaijani</option>
                        <option value="by">Belarusian</option>
                        <option value="ba">Bosnian</option>
                        <option value="bg">Bulgarian</option>
                        <option value="es">Catalan</option>
                      
                        <option value="hr">Croatian</option>
                        <option value="cz">Czech</option>
                        <option value="dk">Danish</option>
                        <option value="nl">Dutch</option>
                        
                        <option value="ee">Estonian</option>
                        <option value="fi">Finnish</option>
                        <option value="fr">French</option>
                        <option value="es">Galician</option>
                        <option value="de">German</option>
                        <option value="gr">Greek</option>
                        <option value="il">Hebrew</option>
                        <option value="in">Hindi</option>
                        <option value="hu">Hungarian</option>
                        <option value="is">Icelandic</option>
                        <option value="id">Indonesian</option>
                        <option value="it">Italian</option>
                        <option value="jp">Japanese</option>
                        <option value="in">Kannada</option>
                        <option value="kz">Kazakh</option>
                        <option value="kr">Korean</option>
                        <option value="lv">Latvian</option>
                        <option value="lt">Lithuanian</option>
                        <option value="mk">Macedonian</option>
                        
                        <option value="in">Marathi</option>
                        <option value="nz">Maori</option>
                        <option value="np">Nepali</option>
                        <option value="no">Norwegian</option>
                        <option value="ir">Persian</option>
                        <option value="pl">Polish</option>
                        <option value="pt">Portuguese</option>
                        <option value="ro">Romanian</option>
                        <option value="ru">Russian</option>
                        <option value="rs">Serbian</option>
                        <option value="sk">Slovak</option>
                        <option value="si">Slovenian</option>
                        <option value="es">Spanish</option>
                        <option value="ke">Swahili</option>
                        <option value="se">Swedish</option>
                        <option value="ph">Tagalog</option>
                      
                        <option value="th">Thai</option>
                        <option value="tr">Turkish</option>
                        <option value="ua">Ukrainian</option>
                        <option value="pk">Urdu</option>
                        <option value="vn">Vietnamese</option>
                        <option value="gb">Welsh</option>
                        
              </select>
  
                        
                    
            </div> 

            <div className="action-button">
              
              <Voice/>
            </div> 

             <div className="vital-signs-section">
                <div className="section-title-a">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M16.5,3C19,3 21,5 21,7.5C21,6.1 19.9,5 18.5,5C17.1,5 16,6.1 16,7.5V16L13.5,18.5C13.1,18.9 12.4,18.9 12,18.5L5.5,12H2V10H6.5L12,15.5L14,13.5V7.5C14,5 16,3 16.5,3M5.41,21L4,19.59L9.59,14L11,15.41L5.41,21Z"/>
                    </svg>
                    Vital Signs
                </div>

                <div className="vital-grid">
                    <div className="vital-item">
                        <div className="vital-icon">
                            <svg viewBox="0 0 24 24">
                                <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M17,13H11V7H12.5V11.5H17V13Z"/>
                            </svg>
                        </div>
                        <div className="vital-input">
                            <div className="vital-label">Blood Pressure</div>
                            <select id="bloodPressure" name="bloodPressure" onChange = {handleSelect}>
                                <option value="">Select level</option>
                                <option value="Low">Low</option>
                                <option value="Normal">Normal</option>
                                <option value="High">High</option>
                            </select>
                        </div>
                    </div>

                    <div className="vital-item">
                        <div className="vital-icon">
                            <svg viewBox="0 0 24 24">
                                <path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z"/>
                            </svg>
                        </div>
                        <div className="vital-input">
                            <div className="vital-label">Heart Rate</div>
                            <select id="heartRate" name="heartRate" onChange = {handleSelect}>
                                <option value="">Select level</option>
                                <option value="Low">Low</option>
                                <option value="Normal">Normal</option>
                                <option value="High">High</option>
                            </select>
                        </div>
                    </div>

                    <div className="vital-item">
                        <div className="vital-icon">
                            <svg viewBox="0 0 24 24">
                                <path d="M12,3L2,12H5V20H19V12H22L12,3M12,8.75A2.25,2.25 0 0,1 14.25,11A2.25,2.25 0 0,1 12,13.25A2.25,2.25 0 0,1 9.75,11A2.25,2.25 0 0,1 12,8.75M12,15C13.5,15 16.5,15.75 16.5,17.25V18H7.5V17.25C7.5,15.75 10.5,15 12,15Z"/>
                            </svg>
                        </div>
                        <div className="vital-input">
                            <div className="vital-label">SPO2</div>
                            <select id="spo2" name="spo2" onChange = {handleSelect}>
                                <option value="">Select level</option>
                                <option value="Low">Low</option>
                                <option value="Normal">Normal</option>
                                <option value="High">High</option>
                            </select>
                        </div>
                    </div>

                    <div className="vital-item">
                        <div className="vital-icon">
                            <svg viewBox="0 0 24 24">
                                <path d="M17,13.24C17,11.34 15.66,9.76 13.87,9.17C14.04,8.81 14.13,8.41 14.13,8C14.13,6.34 12.79,5 11.13,5C9.46,5 8.13,6.34 8.13,8C8.13,8.41 8.21,8.81 8.38,9.17C6.59,9.76 5.25,11.34 5.25,13.24C5.25,13.79 5.36,14.31 5.56,14.78L4.4,15.94C4.03,15.35 3.82,14.65 3.82,13.91C3.82,10.85 6.21,8.37 9.23,8.05C9.05,7.75 8.95,7.39 8.95,7C8.95,5.62 10.07,4.5 11.45,4.5C12.83,4.5 13.95,5.62 13.95,7C13.95,7.39 13.85,7.75 13.67,8.05C16.69,8.37 19.08,10.85 19.08,13.91C19.08,15.28 18.58,16.54 17.76,17.54L16.62,16.4C16.87,15.91 17,15.36 17,14.78V13.24Z"/>
                            </svg>
                        </div>
                        <div className="vital-input">
                            <div className="vital-label">Temperature</div>
                            <select id="temperature" name="temperature" onChange = {handleSelect}>
                                <option value="">Select level</option>
                                <option value="Fever">Fever</option>
                                <option value="Normal">Normal</option>
                                
                            </select>
                        </div>
                    </div>

                    
                </div>
            </div>

            <div >
              <button
                type="submit"
                className="btn btn-primary"               >
                {'Create Task'}
              </button>
            </div>
            
          </div> </form>
          {/* Agenda Section */}
          <div className="agenda-section">          
            
            <div className="agenda-container">
              <h3 className="agenda-title">{template.agenda ? template.agenda["title"]: ""}</h3>
              <p className="agenda-description">
                {template.agenda ? template.agenda["descipt"]: ""}
              </p>
              
               <div>
              <h3 className="checklist-title">Question List</h3>
            
              <div>
      {Object.keys(selected_prompts).map((key) => {
        const isExpanded = expandedKey === key;

        return (
          <div key={key} style={{ marginBottom: '1rem' }}>
            <button
              onClick={() => toggleKey(key)}
              style={{
                backgroundColor: '#f4f4f4',
                border: '1px solid #ccc',
                padding: '10px',
                cursor: 'pointer',
                width: '100%',
                textAlign: 'left',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <span>{key}</span>
              <span style={{ fontSize: '1.2rem' }}>
                {isExpanded ? '🔽' : '▶️'}
              </span>
            </button>

            {isExpanded && (
              <div style={{ padding: '10px', border: '1px solid #ddd', backgroundColor: '#fafafa' }}>
                {selected_prompts[key].map((entry, index) => (
                  <div key={index}>
                    <h4>{entry.title}</h4>
                    <ul>
                      {entry.prompt.map((q) => (
                        <li key={q.id} style={{ marginBottom: '10px' }}>
                          <strong>{q.prompt}</strong>
                          {q.followUps && (
                            <ul style={{ marginTop: '5px', marginLeft: '20px' }}>
                              {q.followUps.map((fu, i) => (
                                <li key={i}>{fu}</li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
            
            
               </div>


            </div>            
          </div>
        </div>
      </div>

       <Alert
        show={showAlert}
        onClose={() => setShowAlert(false)}
        message={alertMessage}
      />

    </div>
  );
};

export default AutoCheckIn;